module.exports = __webpack_public_path__ + "static/about3-37bf5f0c425e86ce0b544061b5d583a5.svg";